export enum TrackingEvent {
  ReportListOpen = `Report list - open`,
  ReportSaved = `Report saved`,
  ReportSavedAsNew = `Report saved as new`,
  ResetState = `Reset state`,
  LaunchTour = `Launch tour`,
}
